export type DownloadFileType = {
  file: BlobPart;
  fileType: string;
  fileName: string;
};

export const downloadFile = ({ file, fileType, fileName }: DownloadFileType): void => {
  const blob = new Blob([file], { type: fileType });
  const urlCreator = window.URL || window.webkitURL;
  const url = urlCreator.createObjectURL(blob);
  const fileDownloadLink = document.createElement('a');
  document.body.appendChild(fileDownloadLink);
  fileDownloadLink.setAttribute('style', 'display: none');
  fileDownloadLink.href = url;
  fileDownloadLink.download = fileName;
  fileDownloadLink.click();
  urlCreator.revokeObjectURL(url);
  document.body.removeChild(fileDownloadLink);
};
